import * as React from 'react';

interface Props {
  children: any;
}
export const ErrorForm = ({ children }: Props) => {
  return <div className="errorForm mediumText4 padding-l-8">{children}</div>;
};
